/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import ChooseType from './ChooseType/index'
import CloseAction from './CloseAction/index'
import Content from './Content/index'
import Form from 'DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Postal/NewAddress/Content/Form/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import NewRelation from './NewRelation/index'
import React from 'react'
import RegisterAction from './RegisterAction/index'
import SearchForPhone from './SearchForPhone/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<NewRelation
  viewPath={`${viewPath}/NewRelation`}
/>
<SearchForPhone
  viewPath={`${viewPath}/SearchForPhone`}
/>
<Form
  viewPath={`${viewPath}/Form`}
/>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width={400}
 height="auto"
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 paddingTop={0}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbc-5-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-6-Z1Yf8zk': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<ChooseType
  viewPath={`${viewPath}/ChooseType`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
<div
  data-testid="Content1.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pb-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btc-7-Z1Yf8zk': dtColorsNeutral200,'--g-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<RegisterAction
  viewPath={`${viewPath}/RegisterAction`}
/>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}